// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/registration/navigation/organization/firstparty/v1/get_user_organization.proto

/* oxlint-disable */
import {
  ApiMembershipRole,
  apiMembershipRoleFromJSON,
  apiMembershipRoleToJSON,
} from "../../../../common/v1/membership_role";

/** Enum for the status of the organization. */
export const ApiStatus = {
  /** STATUS_UNSPECIFIED - Unspecified status. */
  STATUS_UNSPECIFIED: "STATUS_UNSPECIFIED",
  /**
   * kyb_waiting - Organization is waiting for KYB.
   */
  kyb_waiting: "kyb_waiting",
  /**
   * activated - Organization is active.
   */
  activated: "activated",
  /**
   * suspended - Organization is suspended.
   */
  suspended: "suspended",
  /**
   * deactivated - Organization is deactivated.
   */
  deactivated: "deactivated",
} as const;

export type ApiStatus = typeof ApiStatus[keyof typeof ApiStatus];

export namespace ApiStatus {
  export type STATUS_UNSPECIFIED = typeof ApiStatus.STATUS_UNSPECIFIED;
  export type kyb_waiting = typeof ApiStatus.kyb_waiting;
  export type activated = typeof ApiStatus.activated;
  export type suspended = typeof ApiStatus.suspended;
  export type deactivated = typeof ApiStatus.deactivated;
}

export function apiStatusFromJSON(object: any): ApiStatus {
  switch (object) {
    case 0:
    case "STATUS_UNSPECIFIED":
      return ApiStatus.STATUS_UNSPECIFIED;
    case 1:
    case "kyb_waiting":
      return ApiStatus.kyb_waiting;
    case 2:
    case "activated":
      return ApiStatus.activated;
    case 3:
    case "suspended":
      return ApiStatus.suspended;
    case 4:
    case "deactivated":
      return ApiStatus.deactivated;
    default:
      return ApiStatus.STATUS_UNSPECIFIED;
  }
}

export function apiStatusToJSON(object: ApiStatus): string {
  switch (object) {
    case ApiStatus.STATUS_UNSPECIFIED:
      return "STATUS_UNSPECIFIED";
    case ApiStatus.kyb_waiting:
      return "kyb_waiting";
    case ApiStatus.activated:
      return "activated";
    case ApiStatus.suspended:
      return "suspended";
    case ApiStatus.deactivated:
      return "deactivated";
    default:
      return "STATUS_UNSPECIFIED";
  }
}

/** Empty request message for GetUserOrganizations. */
export interface ApiGetUserOrganizationsRequest {
}

/** Response message for retrieving the navigation organizations associated to the logged user. */
export interface ApiGetUserOrganizationsResponse {
  /** The list of organizations. */
  readonly organizations: readonly ApiOrganization[];
}

/** Message for the avatar thumbnail. */
export interface ApiAvatarThumb {
  /** The URL of the avatar thumbnail. */
  readonly fileUrl: string;
}

/** Message for the organization. */
export interface ApiOrganization {
  /** The ID of the organization. */
  readonly id: string;
  /** The name of the organization. */
  readonly name: string;
  /** The avatar thumbnail of the organization. */
  readonly avatarThumb:
    | ApiAvatarThumb
    | null;
  /** The default avatar thumbnail of the organization. */
  readonly defaultAvatarThumb:
    | ApiAvatarThumb
    | null;
  /** The status of the organization. */
  readonly status: ApiStatus;
  /** Whether the organization is under company creation. */
  readonly underCompanyCreation: boolean;
  /** The slug of the organization. */
  readonly slug: string;
  /** The legal country of the organization. */
  readonly legalCountry: string;
  /** The role of the user in the organization. */
  readonly membershipRole: ApiMembershipRole;
}

export const ApiGetUserOrganizationsRequest: MessageFns<ApiGetUserOrganizationsRequest> = {
  fromJSON(_: any): ApiGetUserOrganizationsRequest {
    return {};
  },

  toJSON(_: ApiGetUserOrganizationsRequest): unknown {
    const obj: any = {};
    return obj;
  },
};

export const ApiGetUserOrganizationsResponse: MessageFns<ApiGetUserOrganizationsResponse> = {
  fromJSON(object: any): ApiGetUserOrganizationsResponse {
    return {
      organizations: globalThis.Array.isArray(object?.organizations)
        ? object.organizations.map((e: any) => ApiOrganization.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ApiGetUserOrganizationsResponse): unknown {
    const obj: any = {};
    if (message.organizations?.length) {
      obj.organizations = message.organizations.map((e) => ApiOrganization.toJSON(e));
    }
    return obj;
  },
};

export const ApiAvatarThumb: MessageFns<ApiAvatarThumb> = {
  fromJSON(object: any): ApiAvatarThumb {
    return { fileUrl: isSet(object.file_url) ? globalThis.String(object.file_url) : "" };
  },

  toJSON(message: ApiAvatarThumb): unknown {
    const obj: any = {};
    if (message.fileUrl !== undefined && message.fileUrl !== null) {
      obj.file_url = message.fileUrl;
    }
    return obj;
  },
};

export const ApiOrganization: MessageFns<ApiOrganization> = {
  fromJSON(object: any): ApiOrganization {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      avatarThumb: isSet(object.avatar_thumb) ? ApiAvatarThumb.fromJSON(object.avatar_thumb) : null,
      defaultAvatarThumb: isSet(object.default_avatar_thumb)
        ? ApiAvatarThumb.fromJSON(object.default_avatar_thumb)
        : null,
      status: isSet(object.status) ? apiStatusFromJSON(object.status) : ApiStatus.STATUS_UNSPECIFIED,
      underCompanyCreation: isSet(object.under_company_creation)
        ? globalThis.Boolean(object.under_company_creation)
        : false,
      slug: isSet(object.slug) ? globalThis.String(object.slug) : "",
      legalCountry: isSet(object.legal_country) ? globalThis.String(object.legal_country) : "",
      membershipRole: isSet(object.membership_role)
        ? apiMembershipRoleFromJSON(object.membership_role)
        : ApiMembershipRole.MEMBERSHIP_ROLE_UNSPECIFIED,
    };
  },

  toJSON(message: ApiOrganization): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.name !== undefined && message.name !== null) {
      obj.name = message.name;
    }
    if (message.avatarThumb !== undefined && message.avatarThumb !== null) {
      obj.avatar_thumb = ApiAvatarThumb.toJSON(message.avatarThumb);
    }
    if (message.defaultAvatarThumb !== undefined && message.defaultAvatarThumb !== null) {
      obj.default_avatar_thumb = ApiAvatarThumb.toJSON(message.defaultAvatarThumb);
    }
    if (message.status !== undefined && message.status !== null) {
      obj.status = apiStatusToJSON(message.status);
    }
    if (message.underCompanyCreation !== undefined && message.underCompanyCreation !== null) {
      obj.under_company_creation = message.underCompanyCreation;
    }
    if (message.slug !== undefined && message.slug !== null) {
      obj.slug = message.slug;
    }
    if (message.legalCountry !== undefined && message.legalCountry !== null) {
      obj.legal_country = message.legalCountry;
    }
    if (message.membershipRole !== undefined && message.membershipRole !== null) {
      obj.membership_role = apiMembershipRoleToJSON(message.membershipRole);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
